module.exports = __webpack_public_path__ + "assets/bb62a87fe7dcf87f14649d6a7a7bde49.mp3";